<template>
  <v-container fluid>
    <v-form ref="addForm">
      <v-row>
        <v-col>
          <v-row>
            <v-col cols="12">
              <v-alert type="error" v-if="warning" text>
                {{ warningMessage }}
              </v-alert>
              <v-card :disabled="isSaving" :loading="isSaving">
                <v-toolbar flat>
                  <v-icon left color="accent">mdi-package-variant-closed</v-icon>
                  <v-toolbar-title>Purchase order - Detail</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn @click="save" color="accent">Save</v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="3">
                        <v-text-field
                          v-model="model.poNumber"
                          label="PO Number"
                          hint="Leave empty for autogenerate it"
                        />
                      </v-col>
                      <v-col cols="3">
                        <supplier
                          v-model="model.supplierId"
                          label="Supplier"
                          :rules="[rules.required]"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-select
                          v-model="model.currency"
                          :items="currencies"
                          item-text="currency"
                          item-value="currency"
                          label="Currency"
                        ></v-select>
                      </v-col>
                      <v-col cols="3">
                        <warehouse
                          v-model="model.shipToWarehouse"
                          label="Ship to Warehouse"
                          :rules="[rules.required]"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      
                      <v-col cols="3">
                        <date
                          label="Order Date"
                          v-model="model.orderDate"
                          :rules="[rules.required]"
                        />
                      </v-col>
                      <v-col cols="3">
                        <date
                          label="Requested Ship Date"
                          v-model="model.requestedShipDate"
                        />
                      </v-col>
                      <v-col cols="3">
                        <date
                          label="Order Cancel Date"
                          v-model="model.orderCancelDate"
                        />
                      </v-col>
                      <v-col cols="3">
                        <date
                          label="Arrival Due Date"
                          v-model="model.arrivalDueDate"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="3">
                        <v-select
                          :items="sentStatus"
                          v-model="model.sentStatus"
                          label="Sent Status"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="model.trackingInfo"
                          label="Tracking Info"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-select
                          :items="paymentStatus"
                          v-model="model.paymentStatus"
                          label="Payment Status"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card :disabled="isSaving">
                <v-toolbar flat>
                  <v-icon left color="accent">mdi-format-list-bulleted</v-icon>
                  <v-toolbar-title>PO's Rows</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <add-set :currency="model.currency" @added="addLine($event)" />
                  <add-product
                    :currency="model.currency"
                    ref="addProductForm"
                    @added="addLine($event)"
                  />
                </v-toolbar>
                <v-card-text>
                  <PoLines
                    :items="model.lines"
                    :currency="model.currency"
                    @edit="$refs.editProduct.open($event)"
                    @delete="removeLine($event)"
                  />
                  <edit-product
                    ref="editProduct"
                    :currency="model.currency"
                    @updated="updateLine($event)"
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row>
            <v-col>
              <SupplierProducts
                title="Low stock products for this supplier"
                :products="supplierProducts"
                :lines="model.lines"
                :total="lowStockTotalPage"
                :page="lowStockPage"
                @changePage="lowStockPage = $event"
                @openAddingProductForm="openAddingProductForm($event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <SupplierProducts
                title="Products in pending order for this supplier"
                :products="supplierProductsPending"
                :lines="model.lines"
                :total="pendingTotalPage"
                :page="pendingPage"
                @changePage="pendingPage = $event"
                @openAddingProductForm="openAddingProductForm($event)"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Date from "../../components/Date.vue";
import Supplier from "../../components/forms/autocomplete/Supplier.vue";
import Warehouse from "../../components/forms/select/Warehouse.vue";
import AddProduct from "../../components/purchaseOrder/AddProduct.vue";
import AddSet from "../../components/purchaseOrder/AddSet.vue";
import EditProduct from "../../components/purchaseOrder/EditProduct.vue";
import PoLines from "../../components/purchaseOrder/PoLines.vue";
import SupplierProducts from "../../components/purchaseOrder/SupplierProducts.vue";

export default {
  components: { Date, Supplier, Warehouse, AddProduct, EditProduct, AddSet, PoLines, SupplierProducts },

  data: function() {
    return {
      pendingPage: 1,
      pendingTotalPage: 0,
      lowStockPage:1,
      lowStockTotalPage: 0,
      supplierProducts: [],
      supplierProductsPending: [],
      warning: false,
      warningMessage: "",
      isSaving: false,
      setCurrency: null,
      currency: null,
      poId: null,
      headers: [
        { text: "Sku", value: "product.sku" },
        { text: "Name", value: "product.name" },
        { text: "Unit Cost", value: "cost", align: "right" },
        { text: "Quantity", value: "quantity", align: "right" },
        { text: "Total", value: "total", align: "right" },
        { text: "Actions", value: "actions" },
      ],
      model: {
        poNumber: null,
        orderDate: null,
        orderCancelDate: null,
        supplierId: null,
        shipToWarehouse: null,
        requestedShipDate: null,
        arrivalDueDate: null,
        sentStatus: null,
        trackingInfo: null,
        paymentStatus: null,
        currency: null,
        lines: [],
      },
      rules: {
        required: (value) => !!value || "This field is mandatory.",
      },
      paymentStatus: [
        { text: "None Paid", value: "nonePaid" },
        { text: "Partially Paid", value: "partiallyPaid" },
        { text: "Fully Paid", value: "fullyPaid" },
      ],
      sentStatus: [
        { text: "Not Sent", value: "notSent" },
        { text: "Sent", value: "sent" },
      ],
    };
  },
  computed: {
    ...mapGetters("currencies", ["currencies"]),
    totalQuantity() {
      return this.model.lines.reduce((total, line) => {
        return total + parseInt(line.quantity);
      }, 0);
    },
    totalAmount() {
      return this.model.lines.reduce((total, line) => {
        return total + line.quantity * line.cost;
      }, 0);
    },
  },
  watch : {
    async "model.supplierId" (supplierId) {
      this.getSupplierProductsLowStock({
        id:supplierId,
        rows_per_page: 5,
        page:this.lowStockPage
      }).then(({products}) => {
        this.supplierProducts = products.data
        this.lowStockTotalPage = products.last_page
      })
      this.getSupplierProductsPending({
        id:supplierId,
        rows_per_page: 5,
        page:this.pendingPage
      }).then(({products}) => {
        this.supplierProductsPending = products.data
        this.pendingTotalPage = products.last_page
      })
    },
    lowStockPage () {
      this.getSupplierProductsLowStock({
        id:this.model.supplierId,
        rows_per_page: 5,
        page:this.lowStockPage
      }).then(({products}) => {
        this.supplierProducts = products.data
        this.lowStockTotalPage = products.last_page
      })
    },
    pendingPage () {
      this.getSupplierProductsPending({
        id:this.model.supplierId,
        rows_per_page: 5,
        page:this.pendingPage
      }).then(({products}) => {
        this.supplierProductsPending = products.data
        this.pendingTotalPage = products.last_page
      })
    }
  },
  mounted: function() {
    this.getCurrencies({});
    if (this.$route.params.id) {
      this.poId = this.$route.params.id;
      this.getPO(this.poId);
    }
  },
  methods: {
    ...mapActions("purchaseOrders", ["createOrUpdate"]),
    ...mapActions("currencies", { getCurrencies: "index" }),
    ...mapActions("supplier", {
      getSupplierProductsLowStock: 'productsLowStock',
      getSupplierProductsPending: 'productsPending',
    }),
    getPO(id) {
      this.$store
        .dispatch("purchaseOrders/get", {
          id: id,
        })
        .then((data) => (this.model = data.po));
    },
    save() {
      this.errors = [];
      this.warning = false;
      if (this.$refs.addForm.validate() && this.model.lines.length > 0) {
        this.isSaving = true;

        this.createOrUpdate(this.model)
          .then(({ po }) => {
            this.$router.push("/purchase-order/view/" + po.id);
          })
          .catch(({ data }) => {
            for (const error of Object.entries(data.errors)) {
              this.warningMessage = error[1][0];
              this.warning = true;
            }
          })
          .finally(() => {
            this.isSaving = false;
          });
      }else if(this.model.lines.length === 0){
        this.warningMessage = "Please add at least one line to the PO.";
        this.warning = true;
      }
    },
    addLine(line) {
      let lines = this.model.lines

      if (lines.find((l) => l.product_id == line.product_id)) {
        let idx = lines.findIndex(
          (l) => l.product_id == line.product_id
        );
        lines[idx].quantity = parseInt(lines[idx].quantity) + parseInt(line.quantity);
        lines[idx].unit_cost = line.unit_cost;
      } else {
        lines.push(line);
      }
      this.$set(this.model, 'lines', lines)
    },
    updateLine(item) {
      const idx = this.model.lines.findIndex((l) => l.product_id == item.product_id);
      this.model.lines[idx].quantity = item.quantity;
      this.model.lines[idx].cost = item.cost;
    },
    removeLine(item) {
      const lines = this.model.lines.filter(
        (l) => l.product_id != item.product_id
      );
      this.$set(this.model, 'lines', lines)
      
    },
    openAddingProductForm(product) {
      this.$refs.addProductForm.open(product)
    }
  },
};
</script>

<style></style>
